<script>
import { get, keyBy } from 'lodash'
import moment from 'moment'

export default {
  data() {
    return {
      statuses: [],
      filters: {
        available: [
          {
            name: 'Status exportu',
            query_param: 'status',
            options: this.setStatusOptions
          }
        ],
        selected: {}
      }
    }
  },
  computed: {
    statusesMap() {
      return keyBy(this.statuses, 'value')
    }
  },
  methods: {
    setStatusOptions(options) {
      this.service
        .availableStatuses()
        .then(response => {
          this.statuses = response.data
          options.push(...response.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getLabel(map, value) {
      const labelFound = map.hasOwnProperty(value)
      return (labelFound && map[value].label) || value
    },
    getStatusLabel(instance) {
      return this.getLabel(this.statusesMap, instance.status)
    }
  }
}
</script>
